import React, { useEffect, useState } from 'react';
import { Modal, Box, Grid, Typography, Autocomplete, TextField, Button, MenuItem, Fade, FormControl, InputLabel, Select, OutlinedInput, Checkbox, ListItemText, GlobalStyles } from '@mui/material';
import ApiService from '../../../functions/apiService';
import DuplicateHierarchy from './DuplicateHierarchy';

const DuplicateModal = ({ open, onClose, id , onSubmit }) => {
	const [loading, setLoading] = useState(false);
	const [nestedData, setNestedData] = useState([]);
	const [targets, setTargets] = useState([])

	const getItem = () => {
		const body = {
			"location_id": location
		}
		setLoading(true);
		ApiService.post('/checklist/hirearchy_data', body)
			.then((data) => {
				var load = data?.data.my_items.map((ldd) => { return { label: ldd.item_description, value: ldd.id } })
				setItemDrop(load)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false)
			})
	}

	useEffect(() => {
		getItem()
	}, [id])

	const markAllSelected = (node) => {
		node.selected = true;

		if (node.locations && node.locations.length > 0) {
			node.locations = node.locations.map(markAllSelected);
		}

		if (node.items && node.items.length > 0) {
			node.items = node.items.map(item => ({ ...item, selected: true }));
		}

		return node;
	};

	let loadData = () => {
		const body = {
			"id": id,
		}
		ApiService.post('/checklist/hirearchy_data', body)
			.then((data) => {
				const updatedData = markAllSelected(data?.data);
				setNestedData(updatedData);
			}).catch((e) => {
				console.error("error")
			})
	}

	useEffect(() => {
		loadData();
	}, [id]);

	const buildSubTree = (node) => {
		if (!node.selected) return null;

		const children = [];

		node.locations?.forEach(subLoc => {
			const subTree = buildSubTree(subLoc);
			if (subTree) children.push(subTree);
		});

		node.items?.forEach(item => {
			if (item.selected) {
				children.push({
					description: item?.item?.item_description || '',
					type: 'item'
				});
			}
		});

		return {
			description: node?.location_description || '',
			type: node?.type,
			...(children.length ? { children } : { children: [] }) 
		};
	};

	const buildTargets = (rootNode) => {
		if (!rootNode?.selected) return null;

		const children = [];

		rootNode.locations?.forEach(child => {
			const subTree = buildSubTree(child);
			if (subTree) children.push(subTree);
		});

		rootNode.items?.forEach(item => {
			if (item.selected) {
				children.push({
					description: item?.item?.item_description || '',
					type: 'item'
				});
			}
		});

		return {
			parent_id: rootNode?.location_parent_id,
			description: rootNode?.location_description || '',
			type: rootNode?.type,
			children
		};
	};

	useEffect(() => {
		const updatedTargets = buildTargets(nestedData);
		setTargets(updatedTargets);
	}, [nestedData]);

	const handleCreate = () => {
		const duplicateData =  targets ;

		if (onSubmit) {
			onSubmit(duplicateData);
		}
	};

	return (
		<>
			<GlobalStyles
				styles={{
					'.checklist-modal-box': {
						outline: 'none !important',
					},
				}}
			/>
			<Modal
				open={open}
				onClose={onClose}
				closeAfterTransition
				BackdropProps={{
					timeout: 300,
				}}
			>
				<Fade in={open}>
					<Box
						className="checklist-modal-box"
						sx={{
							position: 'absolute',
							top: '50%',
							left: '50%',
							transform: 'translate(-50%, -50%)',
							width: 800,
							bgcolor: 'background.paper',
							borderRadius: '10px',
							boxShadow: 24,
						}}
					>
						<div style={{ borderBottom: '1px solid #666666', marginBottom: '20px' }}>
							<Box sx={{ py: 1, px: 3 }}>
								<Grid container spacing={3} style={{ alignItems: 'center', justifyContent: 'space-between' }}>
									<Grid item xs={10}>
										<div
											className='mt-2 mb-2'
											style={{fontSize:'20px' }}
										>
											Duplicate Inventory
										</div>
									</Grid>

									<Grid item xs={2} style={{ display: 'flex', justifyContent: 'end' }}>
										<img
											src="/images/close-icon.svg"
											onClick={onClose}
											style={{ cursor: 'pointer' }}
											width={24}
											height={24}
										/>
									</Grid>
								</Grid>
							</Box>
						</div>

						<div>
							<Box sx={{ pb: 5, px: 3, mt: 1 }}>
								<Grid container spacing={2}>
									<Grid item xs={12} sm={6} md={12} sx={{ marginBottom: '20px' }}>
										<div style={{maxHeight:320, minHeight:180, overflow:'scroll', paddingRight:20}}>
											{!id &&
												<Box className='hierarchy-box' >
													<img src='/images/empty.png' style={{ height: 200, width: 250 }}>
													</img>
												</Box>
											}

											{nestedData &&
												<Box>
													<DuplicateHierarchy
														key={nestedData.id}
														propdata={nestedData}
														loadData={loadData}
														location={id}
														parentSelected={nestedData.selected}
														setNestedData={setNestedData}
													/>
												</Box>
											}
										</div>
									</Grid>
								</Grid>
							</Box>
						</div>

						<div className="pb-5 px-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
							<Button variant="contained" color="primary"  onClick={handleCreate}
							>
								Duplicate
							</Button>
						</div>

					</Box>
				</Fade >
			</Modal >
		</>
	);
};

export default DuplicateModal;